export const CarMinEngineVolume: number = 0.8;
export const CarMaxEngineVolume: number = 8.0;
export const CarMinProductionYear: number = 2010;
export const CarMaxProductionYear: number = (new Date()).getFullYear();
export const CarMaxMileage: number = 999_999;
export const CarMaxPrice: number = 12_000_000;
export const CarRangePriceStep: number = 100_000;
export const CarMaxPhotos: number = 25;
export const CarMaxVideos: number = 3;
export const CarMaxDocuments: number = 5;
